



































































































import { Component, Vue } from "vue-property-decorator";
import svgTwitter from "@/components/svg/svg-twitter.vue";
import svgLinkedin from "@/components/svg/svg-linkedin.vue";
import svgInstagram from "@/components/svg/svg-instagram.vue";
import svgFeedBurner from "@/components/svg/svg-feedburner.vue";
import svgYoutube from "@/components/svg/svg-youtube.vue";

@Component({
    components: {
        "svg-twitter": svgTwitter,
        "svg-likedin": svgLinkedin,
        "svg-instagram": svgInstagram,
        "svg-feedburner": svgFeedBurner,
        "svg-youtube": svgYoutube,
    },
})
export default class FmiFooter extends Vue {
    logout() {
        this.$store.dispatch("logout");
    }
}
